/** Format the weekly-credit next-reset instant (an ISO/UTC string from the
 * backend) as a concrete date+time in the **viewer's local timezone**, with the
 * zone abbreviation, e.g. "Mon, Jun 29, 9:00 AM EDT" for an ET viewer or
 * "Mon, Jun 29, 6:00 AM PDT" for a PT viewer. The reset is a fixed instant
 * (Monday 09:00 ET); we show it in local time so each user reads their own
 * clock. ``timeZone`` overrides the local zone (used only by tests for
 * deterministic output). */
export function formatWeeklyReset(isoUtc: string, timeZone?: string): string {
  return new Date(isoUtc).toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
    ...(timeZone ? { timeZone } : {}),
  });
}
